var staticTabReservedNames = ['conversations', 'about'];
/**
 * Converts an incoming Title Acquisition from the Platform Services into a valid App Definition.
 * @param acquisition Title acquisition from Platform Services.
 * @returns {IAppDefinition} App Definition for the title.
 */
export var convertTitleAcquisitionToAppDefinition = function (acquisition) {
    var _a, _b;
    return {
        devicePermissions: acquisition.titleDefinition.devicePermissions || [],
        id: acquisition.appId || acquisition.titleId,
        isFullTrust: acquisition.titleDefinition.isFullTrust || false,
        isLOB: acquisition.titleDefinition.scope === 'Tenant',
        pages: {
            configurable: ((_a = acquisition.titleDefinition.elementDefinitions.configurableTabs) === null || _a === void 0 ? void 0 : _a.map(function (ct) { return ({
                configurationUrl: ct.configurationUrl,
            }); })) || [],
            static: ((_b = acquisition.titleDefinition.elementDefinitions.staticTabs) === null || _b === void 0 ? void 0 : _b.filter(function (st) { return st.name && !staticTabReservedNames.includes(st.name); }).map(function (st) { return ({
                contentUrl: st.contentUrl,
                entityId: st.entityId,
                name: st.name,
            }); })) || [],
        },
        showLoadingIndicator: acquisition.titleDefinition.showLoadingIndicator || false,
        validDomains: acquisition.titleDefinition.validDomains || [],
        version: acquisition.titleDefinition.version,
        webApplicationInfo: acquisition.titleDefinition.webApplicationInfo,
    };
};
//# sourceMappingURL=titleAcquisitionModel.js.map